import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import type { EntityWatcherModel } from '../interfaces';
import { BaseEntity } from './base.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';
import { UserEntity } from './user.entity';

/**
 * Entity for tracking users who are watching an opportunity.
 * Used by the notification system to send activity updates.
 */
@Index('opportunity_user__fk_user__id_fk', ['fkUserId'], {})
@Index('opportunity_user_pk', ['fkOpportunityId', 'fkUserId'], { unique: true })
@Entity('opportunity_user')
export class OpportunityUserEntity
	extends BaseEntity
	implements EntityWatcherModel
{
	@Column('int', { name: '_fk_opportunity__id', unsigned: true })
	public fkOpportunityId!: number;

	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;

	@ManyToOne(
		() => MSmClientOpportunityEntity,
		(opportunity) => opportunity.opportunityUsers,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_opportunity__id', referencedColumnName: 'id' }])
	public fkOpportunity!: MSmClientOpportunityEntity;
}
